module.exports = {
  "title": "solid",
  "id": "wall",
  "info": [
    {
      "text": "Make a piece into a solid so that other pieces can't pass through it",
      "image": "provision/glitches/wall/wall.gif"
    }
  ],
  "category": "rules",
  "color": "blue",
  "icon": "wall",
  "exposedVariables": [
     {
      "tooltip":"Can this piece be pushed?",
      "value": "false",
      "variableName": "pushable?",
      "spriteName": "$glitch_target",
      "input": {
        "type": "boolean"
      }
     },
     {
      "tooltip": "Set how bouncy this piece is",
      "value": "0",
      "variableName": "kick strength",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": 0,
        "max": 50
      }

     }
  ],
  "codeImage": "provision/glitches/wall/wall.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/wall/wall.svg"
};